exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-hot_item[data-v-077e124e]{position:absolute;z-index:2;cursor:pointer}", ""]);

// exports
